import { CopyOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import React from 'react';

import { CAPTION_RTMP_STREAM_URL } from '../config';

type RTCStreamInfoCopierProps = {
  streamKeyVal: string;
};

type SelectItems = {
  baseUrl: boolean;
  keyVal: boolean;
};

function RTCStreamInfoCopier(props: RTCStreamInfoCopierProps) {
  const [selectedItemsToCopy, setSelectedItemsToCopy] = React.useState<SelectItems>({
    baseUrl: false,
    keyVal: false,
  });

  const handleSelection = (selectedItem: 'baseUrl' | 'keyVal') => {
    if (!['baseUrl', 'keyVal'].includes(selectedItem)) {
      console.error('Invalid value selected to copy!');
      return;
    }
    setSelectedItemsToCopy({ ...selectedItemsToCopy, [selectedItem]: !selectedItemsToCopy[selectedItem] });
  };

  const handleCopy = () => {
    if (!selectedItemsToCopy.baseUrl && !selectedItemsToCopy.keyVal) {
      console.warn('Nothing selected to copy!');
      return;
    }

    if (selectedItemsToCopy.baseUrl && selectedItemsToCopy.keyVal) {
      navigator.clipboard.writeText(`${CAPTION_RTMP_STREAM_URL}/${props.streamKeyVal}`);
    } else if (selectedItemsToCopy.baseUrl) {
      navigator.clipboard.writeText(CAPTION_RTMP_STREAM_URL);
    } else {
      navigator.clipboard.writeText(props.streamKeyVal);
    }
  };

  const copyDisabled: boolean = !selectedItemsToCopy.baseUrl && !selectedItemsToCopy.keyVal;

  return (
    <React.Fragment>
      <Tooltip
        title={!selectedItemsToCopy.baseUrl && !selectedItemsToCopy.keyVal ? 'Hakaðu við það sem þú vilt afrita' : ''}
      >
        <Space.Compact block>
          <Button onClick={() => handleSelection('baseUrl')} type={selectedItemsToCopy.baseUrl ? 'primary' : 'default'}>
            {CAPTION_RTMP_STREAM_URL}
          </Button>
          <Button
            id='slash-btn'
            style={{ cursor: 'not-allowed' }}
            type={selectedItemsToCopy.baseUrl && selectedItemsToCopy.keyVal ? 'primary' : 'default'}
          >
            /
          </Button>
          <Button
            onClick={() => handleSelection('keyVal')}
            type={selectedItemsToCopy.keyVal ? 'primary' : 'default'}
            disabled={!props.streamKeyVal}
          >
            {props.streamKeyVal || 'Streymislykill'}
          </Button>
          <Tooltip title={copyDisabled ? '' : 'Afrita'}>
            <Button disabled={copyDisabled} onClick={handleCopy} icon={<CopyOutlined />} />
          </Tooltip>
        </Space.Compact>
      </Tooltip>
    </React.Fragment>
  );
}

export default RTCStreamInfoCopier;
